<template>
  <div>
    <div v-if="loading">
      <b-skeleton width="30%" height="40px"></b-skeleton>
      <b-skeleton
        width="90%"
        height="30px"
        v-for="n in 4"
        :key="n"
      ></b-skeleton>
    </div>
    <div v-else>
      <div class="d-flex align-items-center">
        <!-- <b-avatar rounded size="42" variant="light-primary" class="mr-1">
        <feather-icon :icon="options.icon" size="20" />
      </b-avatar> -->
        <div>
          <h4 class="mb-0 pb-1">
            {{ nameCat }}
          </h4>
          <!-- <span>{{ options.subtitle }}</span> -->
        </div>
      </div>

      <!-- collapse -->
      <app-collapse id="faq-payment-qna" accordion type="margin" class="mt-2">
        <app-collapse-item
          v-for="(data, index) in question"
          :key="index"
          :title="data.question_ar"
        >
          <hr />
          <div class="text-dark line-height-2 mb-1" v-html="data.answer_ar" />
        </app-collapse-item>
      </app-collapse>
    </div>

    <div v-if="question.length == 0 && !loading">
      <alert :massage="$t('alert')" class="w-100"></alert>
    </div>
    <!--/ collapse -->
  </div>
</template>

<script>
import { BAvatar, BSkeleton } from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { mapGetters } from "vuex";
import Alert from "@/components/Alert.vue";

export default {
  components: {
    BAvatar,
    AppCollapseItem,
    AppCollapse,
    Alert,
    BSkeleton,
  },

  props: {
    nameCat: {
      required: false,
    },
  },

  computed: {
    ...mapGetters("NgoProfile/faqNgo", ["question", "loading", "loadingCat"]),
  },
};
</script>
